
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5225',
  depVersions: {
  "data-privacy-request-ui": "static-1.5225",
  "data-fetching-client": "static-1.9374",
  "head-dlb": "static-1.4702",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7681",
  "hub-http-shared-msw-handlers": "static-1.9214",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11124",
  "I18n": "static-7.1541",
  "jasmine-runner": "static-1.6153",
  "privacy-center-public-service-types": "static-1.4488",
  "quartz": "static-1.6583",
  "react-dlb": "static-1.70",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5262",
  "UIComponents": "static-3.8071",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.79",
  "foundations-assets": "static-1.4531",
  "foundations-components": "static-1.7306",
  "foundations-components-test-utils": "static-1.4789",
  "foundations-theming": "static-1.4102",
  "hub-http": "static-1.5872",
  "quartz-config": "static-1.361",
  "quartz-core": "static-1.5802",
  "quick-fetch": "static-1.3637",
  "raven": "static-3.5564",
  "react": "static-7.176",
  "react-rhumb": "static-1.16332",
  "SharedI18nStrings": "static-1.179",
  "ui-addon-i18n": "static-1.10828",
  "usage-tracker": "static-1.7036",
  "usage-tracker-anonymous": "static-1.5453",
  "usage-tracker-core": "static-1.6886",
  "enviro": "static-4.371",
  "hs-promise-rejection-tracking": "static-1.5234",
  "PortalIdParser": "static-2.334",
  "raven-hubspot": "static-1.5871",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3825",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9296",
  "react-redux": "static-7.65",
  "redux": "static-4.16",
  "styled-components": "static-2.83",
  "bend-plugin-trellis-migration": "static-1.3135",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2860",
  "quartz-webpack": "static-1.2807",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.75",
  "HeadJS": "static-2.690",
  "framer-motion": "static-1.65",
  "hs-test-utils-bend-plugin": "static-1.2792",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "ts-schema": "static-1.3812",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.76",
  "react-utils": "static-2.5085",
  "StyleGuideUI": "static-3.482",
  "jasmine": "static-4.4031",
  "rpc-client-utils": "static-1.4304",
  "HubStyle": "static-2.11432",
  "ui-addon-draggable": "static-3.4445",
  "cssUtils": "static-1.698",
  "hs-story-utils": "static-1.9128",
  "icons": "static-2.613",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.92",
  "ui-images": "static-2.1062",
  "bend-plugin-foundations-components": "static-1.3575",
  "floating-ui": "static-1.49",
  "foundations-theming-specialty": "static-1.1818",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.980",
  "ui-fonts": "static-1.386",
  "bend-plugin-foundations-theming": "static-1.2585",
  "foundations-theming-base": "static-1.3087",
  "stylex": "static-1.25",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.770",
  "hubspotter-http": "static-1.4387",
  "mobile-manifest-mixins": "static-1.463",
  "quartz-auth": "static-1.258",
  "quartz-head": "static-1.248",
  "quartz-i18n": "static-1.258",
  "quartz-test": "static-1.258",
  "usage-tracker-container": "static-1.7026",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2805",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.63",
  "sassPrefix": "static-1.150",
  "hubspotter-http-shared-msw-handlers": "static-1.9212"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5225",
  "data-fetching-client": "/data-fetching-client/static-1.9374",
  "head-dlb": "/head-dlb/static-1.4702",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7681",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9214",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11124",
  "I18n": "/I18n/static-7.1541",
  "jasmine-runner": "/jasmine-runner/static-1.6153",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4488",
  "quartz": "/quartz/static-1.6583",
  "react-dlb": "/react-dlb/static-1.70",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5262",
  "UIComponents": "/UIComponents/static-3.8071",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "foundations-assets": "/foundations-assets/static-1.4531",
  "foundations-components": "/foundations-components/static-1.7306",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4789",
  "foundations-theming": "/foundations-theming/static-1.4102",
  "hub-http": "/hub-http/static-1.5872",
  "quartz-config": "/quartz-config/static-1.361",
  "quartz-core": "/quartz-core/static-1.5802",
  "quick-fetch": "/quick-fetch/static-1.3637",
  "raven": "/raven/static-3.5564",
  "react": "/react/static-7.176",
  "react-rhumb": "/react-rhumb/static-1.16332",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10828",
  "usage-tracker": "/usage-tracker/static-1.7036",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5453",
  "usage-tracker-core": "/usage-tracker-core/static-1.6886",
  "enviro": "/enviro/static-4.371",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9296",
  "react-redux": "/react-redux/static-7.65",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.83",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3135",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2860",
  "quartz-webpack": "/quartz-webpack/static-1.2807",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.75",
  "HeadJS": "/HeadJS/static-2.690",
  "framer-motion": "/framer-motion/static-1.65",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2792",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "ts-schema": "/ts-schema/static-1.3812",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.76",
  "react-utils": "/react-utils/static-2.5085",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "jasmine": "/jasmine/static-4.4031",
  "rpc-client-utils": "/rpc-client-utils/static-1.4304",
  "HubStyle": "/HubStyle/static-2.11432",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4445",
  "cssUtils": "/cssUtils/static-1.698",
  "hs-story-utils": "/hs-story-utils/static-1.9128",
  "icons": "/icons/static-2.613",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.92",
  "ui-images": "/ui-images/static-2.1062",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3575",
  "floating-ui": "/floating-ui/static-1.49",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1818",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.980",
  "ui-fonts": "/ui-fonts/static-1.386",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2585",
  "foundations-theming-base": "/foundations-theming-base/static-1.3087",
  "stylex": "/stylex/static-1.25",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.770",
  "hubspotter-http": "/hubspotter-http/static-1.4387",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.463",
  "quartz-auth": "/quartz-auth/static-1.258",
  "quartz-head": "/quartz-head/static-1.248",
  "quartz-i18n": "/quartz-i18n/static-1.258",
  "quartz-test": "/quartz-test/static-1.258",
  "usage-tracker-container": "/usage-tracker-container/static-1.7026",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2805",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.63",
  "sassPrefix": "/sassPrefix/static-1.150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9212"
}
};
